import { __awaiter, __generator } from "tslib";
import { logError } from '@office-start/telemetry-service';
export function getDefaultResources(partnerResourceIdentifier) {
    if (partnerResourceIdentifier === void 0) { partnerResourceIdentifier = 'office-start-resources'; }
    return __awaiter(this, void 0, void 0, function () {
        var errorMessage, retryCount, maxRetries, defaultResources, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    retryCount = 0;
                    maxRetries = 3;
                    _a.label = 1;
                case 1:
                    if (!(retryCount < maxRetries)) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    retryCount++;
                    return [4 /*yield*/, import("./output/OfficeStrings-Versioned/".concat(partnerResourceIdentifier, ".json"))];
                case 3:
                    defaultResources = _a.sent();
                    return [2 /*return*/, defaultResources.default];
                case 4:
                    error_1 = _a.sent();
                    if (retryCount >= maxRetries) {
                        errorMessage = "Failed to import ".concat(partnerResourceIdentifier, " after ").concat(maxRetries, " attempts.\n\nError: ").concat(error_1);
                    }
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 1];
                case 6:
                    logError({
                        eventName: 'GetDefaultResources_Error',
                        errorType: 'LocStrings_Error',
                        message: errorMessage,
                    });
                    throw new Error(errorMessage);
            }
        });
    });
}
//# sourceMappingURL=getDefaultResources.js.map